module.exports = __webpack_public_path__ + "static/media/cancel-circle.d016cb68.svg";